import GuidEventLookupListResultModelBase from '../_generated/modelBases/guid-event-lookup-list-result-model-base';

export default class GuidEventLookupListResultModel extends GuidEventLookupListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
